import { Fragment } from 'react'

import account from './account'
import auth from './auth'
import character from './character'
import event from './event'
import money from './money'
import rank from './rank'
import shop from './shop'

import BlankLayout from '@layouts/BlankLayout'
import VerticalLayout from '@src/layouts/VerticalLayout'
import HorizontalLayout from '@src/layouts/HorizontalLayout'
import LayoutWrapper from '@src/@core/layouts/components/layout-wrapper'

import PublicRoute from '@components/routes/PublicRoute'
import PrivateRoute from '@components/routes/PrivateRoute'

import { isObjEmpty } from '@utils'

const getLayout = {
	blank: <BlankLayout />,
	vertical: <VerticalLayout />,
	horizontal: <HorizontalLayout />
}
const TemplateTitle = '%s'

const DefaultRoute = '/login'

const Routes = [...account, ...auth, ...character, ...event, ...money, ...rank, ...shop]

const getRouteMeta = (route) => {
	if (isObjEmpty(route.element.props)) {
		if (route.meta) {
			return { routeMeta: route.meta }
		} else {
			return {}
		}
	}
}

const MergeLayoutRoutes = (layout, defaultLayout) => {
	const LayoutRoutes = []

	if (Routes) {
		Routes.filter((route) => {
			let isBlank = false

			if (
				(route.meta && route.meta.layout && route.meta.layout === layout) ||
				((route.meta === undefined || route.meta.layout === undefined) && defaultLayout === layout)
			) {
				let RouteTag = PrivateRoute

				if (route.meta) {
					route.meta.layout === 'blank' ? (isBlank = true) : (isBlank = false)
					RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute
				}

				if (route.element) {
					const Wrapper = isObjEmpty(route.element.props) && isBlank === false ? LayoutWrapper : Fragment

					route.element = (
						<Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
							<RouteTag route={route}>{route.element}</RouteTag>
						</Wrapper>
					)
				}

				LayoutRoutes.push(route)
			}
			return LayoutRoutes
		})
	}
	return LayoutRoutes
}

const getRoutes = (layout) => {
	const defaultLayout = layout || 'vertical'
	const layouts = ['vertical', 'horizontal', 'blank']

	const AllRoutes = []

	layouts.forEach((layoutItem) => {
		const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

		AllRoutes.push({
			path: '/',
			element: getLayout[layoutItem] || getLayout[defaultLayout],
			children: LayoutRoutes
		})
	})
	return AllRoutes
}

export { DefaultRoute, TemplateTitle, Routes, getRoutes }
